/* ECLO Régénère A4 — cosmetic reveal only. No offers, carts or content mutation. */
(function(){
 'use strict';
 function boot(scope){
  var root=(scope&&scope.querySelector&&scope.querySelector('[data-eclo-r4-pillars]'))||document.querySelector('[data-eclo-r4-pillars]');
  if(!root||root.dataset.r4Booted==='true')return;
  var children=Array.from(root.querySelectorAll('.eclo-r4-pillar'));
  root.dataset.r4Booted='true';
  if(!children.length||!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion:reduce)').matches){children.forEach(function(x){x.classList.add('eclo-r4-visible')});return;}
  var observer=new IntersectionObserver(function(entries){
   entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('eclo-r4-visible');observer.unobserve(entry.target)}});
  },{threshold:0.08,rootMargin:'0px 0px -8% 0px'});
  children.forEach(function(x){observer.observe(x)});
  root.classList.add('eclo-r4-reveal-ready');
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});else boot(document);
 document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
